import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import PopupWrapper from "../components/PopupWrapper";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { withCookies } from "react-cookie";
import AlertSettings from "../components/AlertSettings";
import AccountSubheader from "../components/AccountSubheader";
import { accountActions } from "../_actions";
import AccountBackButton from "../components/AccountBackButton";

class AccountInfoCareAlerts extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("user"));
    if (!user.user_id) {
      user.user_id = user.dependant_user_id;
    }
    this.props.dispatch(accountActions.getEnergyDetail(user));
  }
  submitAlert = (values) => {
    let alert_notification;
    if (!values.alert_sms && !values.alert_email) {
      alert_notification = 0;
    } else if (!values.alert_sms && values.alert_email) {
      alert_notification = 1;
    } else if (!values.alert_email && values.alert_sms) {
      alert_notification = 2;
    } else if (values.alert_sms && values.alert_email) {
      alert_notification = 3;
    }

    this.props.dispatch(accountActions.setAlert(alert_notification));
  };
  render() {
    const { account } = this.props;

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>

        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backHref="/account/infocare/"
            backLabel="InfoCare"
            title="Alerts"
          />
          <AlertSettings onSubmit={this.submitAlert} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let initialValues = {};

  return {
    initialValues,
    ...state,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "account", // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    enableReinitialize: true,
  })(withCookies(AccountInfoCareAlerts))
);
